/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MegaphoneIcon16Solid = forwardRef('MegaphoneIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.603.63C11.447-.208 13 .32 13 1.609v9.722c0 1.288-1.553 1.816-2.397.977-.182-.18-.357-.357-.53-.53v-.001c-.657-.66-1.25-1.258-1.848-1.745C7.49 9.434 6.844 9.083 6.206 9H2.5A1.5 1.5 0 0 1 1 7.5v-2A1.5 1.5 0 0 1 2.5 4h3.704c.631-.082 1.276-.441 2.014-1.057.561-.468 1.115-1.03 1.722-1.645.213-.216.434-.439.663-.667Z" }),
        React.createElement("path", { d: "M3 13.25V10h4v3.25A1.75 1.75 0 0 1 5.25 15h-.5A1.75 1.75 0 0 1 3 13.25Z" }),
        React.createElement("path", { d: "M15.625 6.5A2.251 2.251 0 0 1 14 8.662V4.338A2.251 2.251 0 0 1 15.625 6.5Z" })));
});
